import ScopeConstants from "constants/ScopeConstants"

export const OutstandingTimesheetAllScope = {
    key: ScopeConstants.OUTSTANDING_TIMESHEET_ALL,
    selector: (state) => state.outstandingTimesheetsAll,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Timesheet/SearchAllOutstanding/",
    updateEndpoint: "/api/Timesheet/UpdateAny/",
}